// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__znX2e"};